/* @flow */
import { List, Map, Record } from 'immutable';

/* Normalizes whitelist records */
export const normalizeWhitelistEntry = (entry: Object): Map<string, any> => {
  return Record(entry)();
};


// WEBPACK FOOTER //
// ./src/app/modules/global-whitelist/utils.js